
import api from "../api/index"

export const createNotice = async (params: {
  dataExpiracao: string,
  tipo: "AVISO" | "ALERTA" | "COMUNICADO" | "PROMOÇÃO" | "",
  mensagem: string
}
) => {
  const response = await api.post("/crud/avisosgerais", params).then((response) => {
    return response.data
  }).catch((error) => {
    ErrorUnknown(error)
  })
  return response
}

export const editNotice = async (params: {
  dataExpiracao: string,
  tipo: "AVISO" | "ALERTA" | "COMUNICADO" | "PROMOÇÃO" | "",
  mensagem: string
  objectId?: string
  expirado: boolean
}
) => {
  const response = await api.put("/crud/avisosgerais", params).then((response) => {
    return response.data
  }).catch((error) => {
    ErrorUnknown(error)
  })
  return response
}

export const getNotices = async () => {
  const response = await api.get("/crud/avisosgerais").then((response) => {
    return response.data
  }).catch((error) => {
    ErrorUnknown(error)
  })
  return response
}
export const deleteNotice = async (id: string) => {
  const response = await api.delete(`/crud/avisosgerais/${id}`).then((response) => {
    return response.data
  }).catch((error) => {
    ErrorUnknown(error)
  })
  return response
}

const ErrorUnknown = (error: any) => {
  throw {
    response: {
      data: {
        message: error.message === "Network Error" ?
          "Erro inesperado! Entre em contato com a equipe de desenvolvimento."
          : error.response.data.message
      }
    }
  }
}